import { render } from "./CruResource.vue?vue&type=template&id=6aa5c133&scoped=true"
import script from "./CruResource.vue?vue&type=script&lang=js"
export * from "./CruResource.vue?vue&type=script&lang=js"

import "./CruResource.vue?vue&type=style&index=0&id=6aa5c133&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa5c133"]])

export default __exports__